import Script from "next/script";
import { useState, useEffect } from 'react'
import Link from "next/link";
import { loadScripts } from "@/lib/loadNewsletterScripts";

export default function Newsletter() {
  useEffect(() => {
    /*
     * It's not possible to have two newsletter forms
     * on a single page using a standard way, so we have
     * to make one of the forms behave as a mirror
     *
     */
    const nameInputElBlog = document.getElementById("_FIRSTNAME");
    const nameInputEl = document.getElementById("FIRSTNAME");
    const handleNameChange = (e) => {
      const value = e.target.value;
      nameInputEl.value = value;
    };

    nameInputElBlog.addEventListener("change", handleNameChange);

    const emailInputElBlog = document.getElementById("_EMAIL");
    const emailInputEl = document.getElementById("EMAIL");
    const handleEmailChange = (e) => {
      const value = e.target.value;
      emailInputEl.value = value;
    };

    emailInputElBlog.addEventListener("change", handleEmailChange);

    return () => {
      nameInputElBlog.removeEventListener("change", handleNameChange);
      emailInputElBlog.removeEventListener("change", handleEmailChange);
    };
  }, []);

  return (
    <section className="w-screen md:h-screen bg-gradient-to-b from-transparent to-[#F7F8F9] flex justify-center items-center ">
      <link
        rel="stylesheet"
        href="https://sibforms.com/forms/end-form/build/sib-styles.css"
      />
      <div className="max-w-8xl text-center text-white py-4 px-8 grid grid-cols-1 sm:grid-cols-2">
        <div className="sm:pl-4">
          <h1 className="small-title !text-secondary text-start pl-0.5 uppercase">Newsletter</h1>
          <div className="main-top-title text-start">Subscribe For The Datopianist</div>
          <p className="body-text text-justify mt-4 pl-0.5 max-w-[40rem] mx-auto ">
            More than 10,000 people have joined the Datopianist - the official
            newsletter of Datopian. Enter your email and get the latest and
            greatest in data, special offers, exclusive news, and a sneak peek
            into new products and services. Delivered to your inbox monthly.
          </p>
        </div>
        <div className="sib-form flex items-center justify-center !font-['Inter'] pr-8 w-full">
          <div id="_sib-form-container" className="!mt-8">
            <form
              id="_sib-form"
              data-type="subscription"
              className="flex flex-col sm:items-baseline lg:items-start items-center  mx-auto gap-x-4 gap-y-2 w-full sm:max-w-2xl md:pl-4"
            >
              <div className="lg:flex-row gap-2 flex flex-col w-full">
                <div className="sib-input sib-form-block !p-0 min-w-[8rem] ">
                  <div className="form__entry entry_block">
                    <div className="entry__field w-full">
                      <input
                        className="input !px-4 !text-black w-full placeholder:!text-gray-400 placeholder:!text-sm "
                        maxLength={200}
                        type="text"
                        id="_FIRSTNAME"
                        name="FIRSTNAME"
                        placeholder="Your name"
                        autoComplete="off"
                        title="First name"
                        data-required="true"
                        required
                      />
                    </div>
                    <label className="entry__error entry__error--primary !max-w-full !text-sm text-left bg-[#ffeded] border-[#ff4949] rounded-md"></label>
                  </div>
                </div>
                <div className="sib-input sib-form-block !p-0 w-full ">
                  <div className="form__entry entry_block">
                    <div className="entry__field w-full">
                      <input
                        className="input !text-black !px-4 w-full placeholder:!text-gray-400 placeholder:!text-sm "
                        type="text"
                        id="_EMAIL"
                        name="EMAIL"
                        placeholder="Your email address"
                        autoComplete="off"
                        title="email"
                        data-required="true"
                        required
                      />
                    </div>
                    <label className="entry__error entry__error--primary !max-w-full !text-sm text-left bg-[#ffeded] border-[#ff4949] rounded-md"></label>
                  </div>
                </div>
              </div>
              <p className="text-secgray text-start max-w-md font-['Inter'] text-xs -mt-1 ml-1">
                Sign up to receive monthly news and updates from Datopian. Your information will be used in accordance with Datopian&apos;s  <Link className="text-orange-400" href="/privacy">privacy policy</Link>. You may opt out at any time.</p>
              <button
                className="sib-form-block__button sib-form-block__button-with-loader relative w-full sm:w-fit sm:!m-0 btn-primary mt-4"
                type="button"
                onClick={async (e) => {
                  e.preventDefault();
                  await new Promise((r) => setTimeout(r, 1000));

                  const nameInputElBlog =
                    document.getElementById("_FIRSTNAME");
                  const nameInputEl =
                    document.getElementById("FIRSTNAME");

                  const nameInputValue = nameInputElBlog.value;

                  const nameErrorElBlog =
                    nameInputElBlog.parentNode.parentNode.getElementsByClassName(
                      "entry__error"
                    )[0];
                  const nameErrorEl =
                    nameInputEl.parentNode.parentNode.getElementsByClassName(
                      "entry__error"
                    )[0];

                  nameErrorElBlog.style = nameErrorEl.style;
                  nameErrorElBlog.innerHTML = nameErrorEl.innerHTML;

                  const emailInputElBlog =
                    document.getElementById("_EMAIL");
                  const emailInputEl = document.getElementById("EMAIL");

                  const emailInputValue = nameInputElBlog.value;

                  const emailErrorElBlog =
                    emailInputElBlog.parentNode.parentNode.getElementsByClassName(
                      "entry__error"
                    )[0];
                  const emailErrorEl =
                    emailInputEl.parentNode.parentNode.getElementsByClassName(
                      "entry__error"
                    )[0];

                  emailErrorElBlog.style = emailErrorEl.style;
                  emailErrorElBlog.innerHTML = emailErrorEl.innerHTML;

                  const form = document
                    .getElementById("sib-form")
                    .getElementsByTagName("button")[0]
                    .click();
                }}
              >
                <svg
                  className="icon clickable__icon progress-indicator__icon sib-hide-loader-icon absolute left-1/3 !m-0 h-6"
                  viewBox="0 0 512 512"
                >
                  <path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z" />
                </svg>
                Subscribe
              </button>
              <input
                type="text"
                name="email_address_check"
                defaultValue=""
                className="hidden"
                aria-hidden={true}
              />
              <input type="hidden" name="locale" defaultValue="en" aria-hidden={true} />
            </form>
            <div
              id="_error-message"
              className="sib-form-message-panel !w-fit !m-0 !mt-4 text-base text-left text-[#661d1d] bg-[#ffeded] border border-[#ff4949] rounded"
            >
              <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
                <svg
                  viewBox="0 0 512 512"
                  className="sib-icon sib-notification__icon"
                >
                  <path d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z" />
                </svg>
                <span className="sib-form-message-panel__inner-text">
                  Your subscription could not be saved. Please try again.
                </span>
              </div>
            </div>
            <div
              id="_success-message"
              className="sib-form-message-panel !w-fit !m-0 !mt-4 text-base text-left text-[#085229] bg-[#e7faf0] border border-[#13ce66] rounded"
            >
              <div className="sib-form-message-panel__text sib-form-message-panel__text--center">
                <svg
                  viewBox="0 0 512 512"
                  className="sib-icon sib-notification__icon"
                >
                  <path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 464c-118.664 0-216-96.055-216-216 0-118.663 96.055-216 216-216 118.664 0 216 96.055 216 216 0 118.663-96.055 216-216 216zm141.63-274.961L217.15 376.071c-4.705 4.667-12.303 4.637-16.97-.068l-85.878-86.572c-4.667-4.705-4.637-12.303.068-16.97l8.52-8.451c4.705-4.667 12.303-4.637 16.97.068l68.976 69.533 163.441-162.13c4.705-4.667 12.303-4.637 16.97.068l8.451 8.52c4.668 4.705 4.637 12.303-.068 16.97z" />
                </svg>
                <span className="sib-form-message-panel__inner-text">
                  Your subscription has been successful!
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}